import { render } from "./GamePad.vue?vue&type=template&id=a3aa68f4"
import script from "./GamePad.vue?vue&type=script&lang=js"
export * from "./GamePad.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__